import { render, staticRenderFns } from "./GlueAgreement.vue?vue&type=template&id=9a12e3f8&scoped=true&"
import script from "./GlueAgreement.vue?vue&type=script&lang=js&"
export * from "./GlueAgreement.vue?vue&type=script&lang=js&"
import style0 from "./GlueAgreement.vue?vue&type=style&index=0&id=9a12e3f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a12e3f8",
  null
  
)

export default component.exports